import api from '@/config/Api'
import { formatFormDataBody } from '@/utils/format'

const baseEndpoint = '/network/import-files'
const baseEndpointVertical = '/network/import-files-vertical'
const baseEndpointWater = '/network/import-water-files'

export default {
  importFile (data) {
    return api.post('/network/import-file', formatFormDataBody(data))
  },

  importFileVertical (data) {
    return api.post('/network/import-file-vertical', formatFormDataBody(data))
  },

  importFileWater (data) {
    return api.post('/network/import-water-file', formatFormDataBody(data))
  },

  getImportFile (id) {
    return api.get(`/network/import-file/${id}`)
  },

  getImportFileVertical (id) {
    return api.get(`/network/import-file-vertical/${id}`)
  },

  getImportFileWater (id) {
    return api.get(`/network/import-water-file/${id}`)
  },

  getImports (params) {
    return api.get(baseEndpoint, params)
  },

  getImportsVertical (params) {
    return api.get(baseEndpointVertical, params)
  },

  getImportsWater (params) {
    return api.get(baseEndpointWater, params)
  }
}
